import { BaseEntity } from '../../../xform-compat';
import { CompanyBasic } from '../company/company-basic.model';
import { Person } from '../person.model';
import { TradeRestrictionLevel } from '../../enums/trade-restriction-level.enum';
import { TradeRestrictionReason } from '../../enums/trade-restriction-reason.enum';
import { BasicUser } from '../basicUser.model';
import { DateTime } from 'luxon';
import { CONFIG } from '../../../config';
import { DateTimeService } from '../../../core/services';

export class TradeRestriction implements BaseEntity {
  id: number;
  company: CompanyBasic;
  person: Person;
  reason: TradeRestrictionReason;
  startDate: DateTime;
  endDate: DateTime;
  endReason: string;
  details: string;
  level: TradeRestrictionLevel;
  boardSeatId: number;
  netLevel: TradeRestrictionLevel;
  lastModified: DateTime;
  lastModifiedBy: BasicUser;
  active: boolean;

  constructor(tradeRestriction: any = {}) {
    this.id = tradeRestriction.id || null;
    this.company = tradeRestriction.company || null;
    this.person = tradeRestriction.person || null;
    this.reason = TradeRestrictionReason[String(tradeRestriction.reason)] || null;
    this.startDate = typeof tradeRestriction.startDate === 'string' ?
      DateTimeService.parseDate(tradeRestriction.startDate, CONFIG.timezoneUTC).setZone('America/New_York')
      : tradeRestriction.startDate;
    this.endDate = typeof tradeRestriction.endDate === 'string' ?
      DateTimeService.parseDate(tradeRestriction.endDate, CONFIG.timezoneUTC).setZone('America/New_York')
      : tradeRestriction.endDate;
    this.endReason = tradeRestriction.endReason || null;
    this.details = tradeRestriction.details || null;
    this.level = TradeRestrictionLevel[String(tradeRestriction.level)] || null;
    this.boardSeatId = tradeRestriction.boardSeatId || null;
    this.netLevel = TradeRestrictionLevel[String(tradeRestriction.netLevel)] || null;
    this.lastModified = typeof tradeRestriction.lastModified === 'string' ?
      DateTimeService.parseDate(tradeRestriction.lastModified, CONFIG.timezoneUTC).setZone('America/New_York')
      : tradeRestriction.lastModified;
    this.lastModifiedBy = tradeRestriction.lastModifiedBy ? new BasicUser(tradeRestriction.lastModifiedBy) : null;
    this.active = tradeRestriction.active !== undefined ? tradeRestriction.active : true;
  }
}

export class CreateTradeRestriction {
  companyId: number;
  personId: number;
  reason: TradeRestrictionReason;
  startDate: DateTime;
  endDate: DateTime;
  endReason: string;
  details: string;
  level: TradeRestrictionLevel;
  boardSeatId: number;

  constructor(tradeRestriction?: TradeRestriction) {
    this.companyId = tradeRestriction && tradeRestriction.company ? tradeRestriction.company.id : null;
    this.personId = tradeRestriction && tradeRestriction.person ? tradeRestriction.person.id : null;
    this.reason = tradeRestriction ? tradeRestriction.reason : null;
    this.startDate = tradeRestriction ? tradeRestriction.startDate : null;
    this.endDate = tradeRestriction ? tradeRestriction.endDate : null;
    this.endReason = tradeRestriction ? tradeRestriction.endReason : null;
    this.details = tradeRestriction ? tradeRestriction.details : null;
    this.level = tradeRestriction ? tradeRestriction.level : null;
    this.boardSeatId = tradeRestriction ? tradeRestriction.boardSeatId : null;
  }
}
